module.exports = __webpack_public_path__ + "static/media/Si_Scoring_logo_dark_text_2.ad9b19ff.svg";